import { ChirpErrorType, ChirpSubCategoryError, ErrorsType } from '../constants/commonConstants';
import { getConnectedAppUrl } from './urls';
const subCategoryError = [ErrorsType.ERROR_WITH_MESSAGE_OUTPUT_TO_USER, ErrorsType.ERROR_WITHOUT_MESSAGE_OUTPUT_TO_USER];
export const isErrorWithoutMessageOutputToUser = errorData => {
  var _errorData$context;
  return errorData === null || errorData === void 0 || (_errorData$context = errorData.context) === null || _errorData$context === void 0 || (_errorData$context = _errorData$context.subCategory) === null || _errorData$context === void 0 ? void 0 : _errorData$context.includes(ErrorsType.ERROR_WITHOUT_MESSAGE_OUTPUT_TO_USER);
};
export const getJSONObject = jsonString => {
  try {
    const data = JSON.parse(jsonString);
    return data && typeof data === 'object' ? data : null;
  } catch (error) {
    return null;
  }
};
export const parseApolloError = errorResponse => {
  var _errorResponse$cause;
  return errorResponse && ((_errorResponse$cause = errorResponse.cause) === null || _errorResponse$cause === void 0 ? void 0 : _errorResponse$cause.cause);
};
export const isIntegrationDisconnectedError = errorData => {
  var _errorData$subCategor;
  return errorData.category === 'FORBIDDEN' && (errorData === null || errorData === void 0 || (_errorData$subCategor = errorData.subCategory) === null || _errorData$subCategor === void 0 ? void 0 : _errorData$subCategor.includes('INTEGRATION_DISCONNECTED_ERROR'));
};
export const isForbiddenError = error => {
  var _errorData$subCategor2;
  const errorData = getJSONObject(error.data);
  return (errorData === null || errorData === void 0 || (_errorData$subCategor2 = errorData.subCategory) === null || _errorData$subCategor2 === void 0 ? void 0 : _errorData$subCategor2.includes('FORBIDDEN_ERROR')) && subCategoryError.some(subCategory => {
    var _errorData$context2;
    return errorData === null || errorData === void 0 || (_errorData$context2 = errorData.context) === null || _errorData$context2 === void 0 || (_errorData$context2 = _errorData$context2.subCategory) === null || _errorData$context2 === void 0 ? void 0 : _errorData$context2.includes(subCategory);
  });
};
export const isNotFoundError = error => {
  var _errorData$subCategor3;
  const errorData = getJSONObject(error.data);
  return (errorData === null || errorData === void 0 || (_errorData$subCategor3 = errorData.subCategory) === null || _errorData$subCategor3 === void 0 ? void 0 : _errorData$subCategor3.includes('NOT_FOUND')) && subCategoryError.some(subCategory => {
    var _errorData$context3;
    return errorData === null || errorData === void 0 || (_errorData$context3 = errorData.context) === null || _errorData$context3 === void 0 || (_errorData$context3 = _errorData$context3.subCategory) === null || _errorData$context3 === void 0 ? void 0 : _errorData$context3.includes(subCategory);
  });
};
export const isThirdPartyOutageError = errorData => {
  var _errorData$subCategor4;
  return (errorData === null || errorData === void 0 || (_errorData$subCategor4 = errorData.subCategory) === null || _errorData$subCategor4 === void 0 ? void 0 : _errorData$subCategor4.includes('THIRD_PARTY_OUTAGE_ERROR')) && subCategoryError.some(subCategory => {
    var _errorData$context4;
    return errorData === null || errorData === void 0 || (_errorData$context4 = errorData.context) === null || _errorData$context4 === void 0 || (_errorData$context4 = _errorData$context4.subCategory) === null || _errorData$context4 === void 0 ? void 0 : _errorData$context4.includes(subCategory);
  });
};
export const isChirpErrorWithMessageOutputToUser = errorData => {
  return (errorData === null || errorData === void 0 ? void 0 : errorData.subCategory) === ChirpSubCategoryError.ERROR_WITH_MESSAGE_OUTPUT_TO_USER;
};
export const isChirpNotFoundError = errorData => {
  return (errorData === null || errorData === void 0 ? void 0 : errorData.errorType) === ChirpErrorType.NOT_FOUND;
};
export const errorLabels = {
  [ErrorsType.GENERIC_ERROR]: {
    title: 'videoConference.alerts.errors.failedToFetch.title',
    message: 'videoConference.alerts.errors.failedToFetch.message_jsx'
  },
  [ErrorsType.INTEGRATION_SETTINGS_NOT_FOUND_ERROR]: {
    title: 'videoConference.alerts.errors.failedIntegrationSettings.title',
    message: 'videoConference.alerts.errors.failedIntegrationSettings.message_jsx'
  },
  [ErrorsType.GET_WEBINARS_ERROR]: {
    title: 'videoConference.alerts.errors.failedFetchWebinars.title',
    message: 'videoConference.alerts.errors.failedFetchWebinars.message_jsx'
  },
  [ErrorsType.GET_USERS_ERROR]: {
    title: 'videoConference.alerts.errors.failedFetchUsers.title',
    message: 'videoConference.alerts.errors.failedFetchUsers.message_jsx'
  },
  [ErrorsType.SYNC_WEBINAR_ERROR]: {
    title: 'videoConference.alerts.errors.failedSyncWebinar.title',
    message: 'videoConference.alerts.errors.failedSyncWebinar.message'
  },
  [ErrorsType.GET_EXCLUSION_ERROR]: {
    title: 'videoConference.alerts.errors.failedGetExclusion.title',
    message: 'videoConference.alerts.errors.failedGetExclusion.message_jsx'
  },
  [ErrorsType.SAVE_EXCLUSION_ERROR]: {
    title: 'videoConference.alerts.errors.failedSaveExclusion.title',
    message: 'videoConference.alerts.errors.failedSaveExclusion.message'
  },
  [ErrorsType.GET_NEWLY_WEBINAR_SYNC_ERROR]: {
    title: 'videoConference.alerts.webinarSettings.failedGet.title',
    message: 'videoConference.alerts.webinarSettings.failedGet.message_jsx'
  },
  [ErrorsType.GET_GLOBAL_SYNC_WEBINARS_ERROR]: {
    title: 'videoConference.alerts.webinarSettings.failedGet.title',
    message: 'videoConference.alerts.webinarSettings.failedGet.message_jsx'
  },
  [ErrorsType.GET_USER_RECORDING_SYNC_WEBINAR_ERROR]: {
    title: 'videoConference.alerts.webinarSettings.failedGet.title',
    message: 'videoConference.alerts.webinarSettings.failedGet.message_jsx'
  },
  [ErrorsType.SAVE_WEBINAR_SETTINGS_ERROR]: {
    title: 'videoConference.alerts.webinarSettings.failedSave.title',
    message: 'videoConference.alerts.webinarSettings.failedSave.message'
  },
  [ErrorsType.GET_USER_SYNC_SETTINGS_ERROR]: {
    title: 'videoConference.alerts.errors.failedGetUserSyncSettings.title',
    message: 'videoConference.alerts.errors.failedGetUserSyncSettings.message_jsx'
  },
  [ErrorsType.SAVE_USER_SYNC_SETTINGS_ERROR]: {
    title: 'videoConference.alerts.globalSync.userSettings.savedFailure.title',
    message: 'videoConference.alerts.globalSync.userSettings.savedFailure.message'
  },
  [ErrorsType.INTEGRATION_DISCONNECTED_FOR_USERS_ERROR]: {
    title: 'videoConference.alerts.errors.integrationDisconnected.users.title',
    message: 'videoConference.alerts.errors.integrationDisconnected.users.message'
  },
  [ErrorsType.INTEGRATION_DISCONNECTED_FOR_WEBINARS_ERROR]: {
    title: 'videoConference.alerts.errors.integrationDisconnected.webinars.title',
    message: 'videoConference.alerts.errors.integrationDisconnected.webinars.message'
  },
  [ErrorsType.INTEGRATION_DISCONNECTED_FOR_WEBINAR_FORMS_ERROR]: {
    title: 'videoConference.alerts.errors.integrationDisconnected.webinarForms.title',
    message: 'videoConference.alerts.errors.integrationDisconnected.webinarForms.message_jsx',
    link: getConnectedAppUrl()
  },
  [ErrorsType.WEBINAR_FORMS_PERMISSIONS_ERROR]: {
    title: 'videoConference.alerts.errors.failedPermissionsWebinar.noPermissions.title',
    message: 'videoConference.alerts.errors.failedPermissionsWebinar.noPermissions.message_jsx',
    link: getConnectedAppUrl()
  },
  [ErrorsType.SAVE_WEBINAR_SETTINGS_AT_DISCONNECTED_STATUS_ERROR]: {
    title: 'videoConference.alerts.webinarSettings.failedSaveAtIntegrationDisconnected.title',
    message: 'videoConference.alerts.webinarSettings.failedSaveAtIntegrationDisconnected.message'
  },
  [ErrorsType.SYNC_WEBINAR_AT_DISCONNECTED_STATUS_ERROR]: {
    title: 'videoConference.alerts.errors.failedSyncWebinarAtIntegrationDisconnected.title',
    message: 'videoConference.alerts.errors.failedSyncWebinarAtIntegrationDisconnected.message'
  },
  [ErrorsType.THIRD_PARTY_OUTAGE_FOR_USERS_ERROR]: {
    title: 'videoConference.alerts.errors.thirdPartyOutageError.users.title',
    message: 'videoConference.alerts.errors.thirdPartyOutageError.users.message'
  },
  [ErrorsType.THIRD_PARTY_OUTAGE_FOR_WEBINARS_ERROR]: {
    title: 'videoConference.alerts.errors.thirdPartyOutageError.webinars.title',
    message: 'videoConference.alerts.errors.thirdPartyOutageError.webinars.message'
  },
  [ErrorsType.THIRD_PARTY_OUTAGE_FOR_WEBINARS_FORM_ERROR]: {
    title: 'videoConference.alerts.errors.thirdPartyOutageError.webinarForm.title',
    message: 'videoConference.alerts.errors.thirdPartyOutageError.webinarForm.message'
  },
  [ErrorsType.WEBINAR_FORMS_APP_STATUS_ERROR]: {
    title: 'videoConference.alerts.errors.failedAppStatus.title',
    message: 'videoConference.alerts.errors.failedAppStatus.message_jsx'
  },
  [ErrorsType.MEETINGS_NOT_FOUND_ERROR]: {
    title: 'videoConference.alerts.errors.meetings.search.notFound.title',
    message: 'videoConference.alerts.errors.meetings.search.notFound.message'
  },
  [ErrorsType.THIRD_PARTY_OUTAGE_FOR_MEETINGS_SEARCH]: {
    title: 'videoConference.alerts.errors.meetings.search.thirdPartyOutageError.title',
    message: 'videoConference.alerts.errors.meetings.search.thirdPartyOutageError.message'
  },
  [ErrorsType.MEETINGS_DEFAULT_ERROR]: {
    title: 'videoConference.alerts.errors.meetings.default.title',
    message: 'videoConference.alerts.errors.meetings.default.message_jsx'
  },
  [ErrorsType.MEETINGS_SYNC_INTERNAL_ERROR]: {
    title: 'videoConference.alerts.errors.meetings.sync.internalError.title',
    message: 'videoConference.alerts.errors.meetings.sync.internalError.message_jsx'
  }
};